export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
export const NOT_FOUND = 'NOT_FOUND';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';

export const STATUS_CODE_ERROR_CODE = {
  401: AUTHENTICATION_FAILED,
  404: NOT_FOUND,
  default: UNKNOWN_ERROR
};

export const ERROR_CODE_ERROR_MESSAGE = {
  [AUTHENTICATION_FAILED]: {
    errorCode: AUTHENTICATION_FAILED,
    message: 'webOnly.errors.authFailed.message',
    data: {
      error: 'webOnly.errors.authFailed.error',
      link:
        'https://legacy.easyvote.ch/de/community/kennwort-vergessen/?tx_felogin_pi1%5Bforgot%5D=1 oder schreibe eine E-Mail an info@easyvote.ch.'
    }
  },
  [NOT_FOUND]: {
    errorCode: NOT_FOUND,
    message: 'webOnly.errors.userNotFound.message',
    data: {
      error: 'webOnly.errors.userNotFound.error',
      link: {
        text: 'easyvote.ch',
        link: 'https://www.easyvote.ch/'
      }
    }
  },
  [UNKNOWN_ERROR]: {
    errorCode: UNKNOWN_ERROR,
    message: 'webOnly.errors.unknownError.message'
  }
};

export const makeErrorGetter = errorCodeErrorMessageStrategy => statusCode => {
  const errorCode = STATUS_CODE_ERROR_CODE[statusCode] || STATUS_CODE_ERROR_CODE.default;
  return errorCodeErrorMessageStrategy[errorCode];
};

export const getAuthErrorDataByStatusCode = makeErrorGetter(ERROR_CODE_ERROR_MESSAGE);
